import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Login = ({ setShowLogin }) => {
  const [responseMessage, setResponseMessage] = useState(false);
  const [error, setError] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await axios.post(
        "https://api.swalokgroup.com/api/login",
        { phone, password },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      localStorage.setItem("user", JSON.stringify(response.data));
      setResponseMessage("Login Successful");

      setTimeout(() => {
        setResponseMessage("");
        if (response.data.id === 1) {
          navigate("/admin/dashboard", { state: response.data });
          window.location.reload();
        } else {
          navigate("/user/dashboard", { state: response.data });
          window.location.reload();
        }
      }, 1000);
    } catch (error) {
      setError("Login Failed. Mobile Number not exist");
    }
  };

  return (
    <>
      <section className="my-5">
        <div className="container text-center">
          <div className="sec-subheading">
            <hr />
            <span>Login</span>
            <hr />
          </div>
          <p className="sec-heading">Get into your Account</p>

          <div className="bg-body-tertiary px-4 py-5 mt-4 col-lg-5 col-md-10 col-12 mx-auto text-start">
            <form className="row g-3" onSubmit={handleLogin}>
              <div className="col-12">
                <input
                  type="tel"
                  className="form-input"
                  name="phone"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="Your Phone"
                  required
                />
              </div>
              <div className="col-12">
                <input
                  type="password"
                  className="form-input"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter Password"
                  required
                />
              </div>
              {error && <div className="text-danger">{error}</div>}
              <div className="col-12 my-4">
                <button type="submit" className="banner-btn w-100">
                  Login
                </button>
              </div>
            </form>
            <p className="text-center fst-italic">
              Didn't have an Account?{" "}
              <span className="toggle-link" onClick={() => setShowLogin(false)}>
                Signin
              </span>{" "}
              Here.
            </p>

            {/* form ends */}
          </div>
        </div>
        {responseMessage && (
          <div className="response-message d-flex justify-content-between">
            <p className="my-0 mx-auto">{responseMessage}</p>
            <p
              className="my-0 cursor-pointer"
              onClick={() => setResponseMessage(false)}
            >
              <i className="fa-solid fa-xmark"></i>
            </p>
          </div>
        )}
      </section>
    </>
  );
};

export default Login;
